/* Zabi UGC-videocarousel — pijl-navigatie (scroll-snap) + inline video-play.
   Echte <video>-elementen (poster + preload=none). Eén video tegelijk.
   Geen externe libraries. */
(function () {
  var CARD_STEP = 268; /* 248 kaart + 20 gap */

  function initSection(root) {
    var track = root.querySelector('[data-ugc-track]');
    if (!track) return;

    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');

    function step() {
      var card = track.querySelector('.zabi-ugc__card');
      if (!card) return CARD_STEP;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* Echte video's: één tegelijk. Bij 'play' pauzeer alle andere en toon
       de player (overlay/poster verbergen via CSS-klasse). */
    var videos = track.querySelectorAll('[data-ugc-video]');
    videos.forEach(function (v) {
      v.addEventListener('play', function () {
        var media = v.closest('.zabi-ugc__media');
        if (media) media.classList.add('zabi-ugc__media--playing');
        videos.forEach(function (o) { if (o !== v) o.pause(); });
      });
    });

    /* Play-knop of kaart-tik: start de eigen video (met geluid) of val terug
       op een YouTube/Vimeo-embed voor legacy URL's zonder echt video-element. */
    track.querySelectorAll('.zabi-ugc__play').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var media = btn.closest('.zabi-ugc__media');
        if (!media) return;
        var v = media.querySelector('[data-ugc-video]');
        if (v) {
          v.muted = false;
          v.setAttribute('controls', '');
          var p = v.play();
          if (p && p.catch) {
            p.catch(function () { v.muted = true; v.play(); });
          }
          return;
        }
        var url = btn.getAttribute('data-video');
        if (!url) return;
        media.innerHTML = buildPlayer(url);
      });
    });
  }

  function buildPlayer(url) {
    var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/)([\w-]+)/);
    if (yt) {
      return frame('https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0');
    }
    var vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vim) {
      return frame('https://player.vimeo.com/video/' + vim[1] + '?autoplay=1');
    }
    return '<video src="' + escapeAttr(url) + '" autoplay muted playsinline controls></video>';
  }

  function frame(src) {
    return '<iframe src="' + escapeAttr(src) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
  }

  function escapeAttr(s) {
    return String(s).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function initAll() {
    document.querySelectorAll('[data-ugc-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify theme-editor: her-init bij sectie-load */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ugc-root]');
    if (root) initSection(root);
  });
})();
